
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface FlagshipProduct {
  name: string;
  icon: React.ElementType;
  description: string;
  href: string;
  cta: string;
}
interface ProductFlagshipGridProps {
  products: FlagshipProduct[];
  onClose: () => void;
  onNavigationClick?: (href: string) => void;
}

export const ProductFlagshipGrid: React.FC<ProductFlagshipGridProps> = ({ products, onClose, onNavigationClick }) => {
  const handleLinkClick = (href: string, e: React.MouseEvent) => {
    if (onNavigationClick) {
      e.preventDefault();
      onNavigationClick(href);
    }
    onClose();
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-3">
      {products.map((p) => (
        <Link
          to={p.href}
          key={p.name}
          onClick={(e) => handleLinkClick(p.href, e)}
          className="group flex flex-col gap-1.5 items-start p-3 transition-all duration-200 border border-gray-200 hover:border-blue-300 hover:bg-blue-50/50 focus:bg-blue-50/60 focus:ring-2 focus:ring-blue-200"
          style={{ minHeight: 85 }}
        >
          <div className="flex items-center gap-2 mb-1">
            <p.icon className="w-6 h-6 text-muted-foreground group-hover:text-blue-600 transition-colors" />
            <span className="text-lg font-medium text-gray-900 group-hover:text-blue-700">{p.name}</span>
          </div>
          <div className="text-xs text-gray-600 leading-relaxed">{p.description}</div>
          <Button
            className="mt-2 rounded-full px-4 py-1 bg-gray-100 text-gray-900 text-xs font-normal shadow-none hover:bg-blue-600 hover:text-white hover:shadow-sm border-0 transition"
            variant="ghost"
            size="sm"
            tabIndex={-1}
          >
            {p.cta}
            <ArrowRight className="ml-1 w-3 h-3" />
          </Button>
        </Link>
      ))}
    </div>
  );
};
